// extracted by mini-css-extract-plugin
module.exports = {"blocker":"Protected_blocker__IR8F1"};